import React from 'react';
import moment from "moment";
import { Tag } from 'antd';
import { Link } from "react-router-dom";
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { openDSWindow } from '../../../../../../helpers/Window';

const columns = (t = (s) => s, mod = 'pme') => ({
  incidents: [
    {
      title: t('ID'),
      dataIndex: 'datastakeId',
      render: (id) => {
        if (isProxy()) {
          return (
            <a
              href="#"
              onClick={() => {
                openDSWindow({
                  url: `/proxy/${mod}/view/event/${id}`,
                  name: `Event ${id}`,
                });
              }}
            >
              {id}
            </a>
          )
        }
        return <Link target="_blank" to={`/app/${mod}/view/event/${id}`}>{id}</Link>
      },
      sorter: (a, b) => ('' + a.datastakeId).localeCompare(b.datastakeId),
    },
    {
      title: t('Title'),
      dataIndex: 'title',
      ellipsis: true,
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
    },
    {
      title: t('Severity'),
      dataIndex: 'category',
      render: (category) => {
        if (category) {
          switch (category.value) {
            case 'major':
              return <Tag className="w-50 text-center" color="red">{category.label}</Tag>
            case 'moderate':
              return <Tag className="w-50 text-center" color="orange">{category.label}</Tag>
            case 'minor':
              return <Tag className="w-50 text-center" color="yellow">{category.label}</Tag>
            default:
              return '';
          }
        }
        return '';
      },
      sorter: (a, b) => ('' + a.category).localeCompare(b.category),
    },
    {
      title: t('Location'),
      dataIndex: 'location',
      sorter: (a, b) => ('' + a.location).localeCompare(b.location),
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      render: (value) => {
        return moment(value).format('DD MMM YYYY');
      },
      sorter: (a, b) => moment(a.dateOfEvent).diff(moment(b.dateOfEvent)),
    },
  ],
  mitigationActions: [
    {
      title: t('ID'),
      dataIndex: 'datastakeId',
      render: (id) => {
        if (isProxy()) {
          return (
            <a
              href="#"
              onClick={() => {
                openDSWindow({
                  url: `/proxy/${mod}/view/event/${id}`,
                  name: `Event ${id}`,
                });
              }}
            >
              {id}
            </a>
          )
        }
        return <Link target="_blank" to={`/app/${mod}/view/event/${id}`}>{id}</Link>
      },
      sorter: (a, b) => ('' + a.datastakeId).localeCompare(b.datastakeId),
    },
    {
      title: t('Title'),
      dataIndex: 'title',
      ellipsis: true,
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
    },
    {
      title: t('Type'),
      dataIndex: 'category',
      render: (categories) => {
        if (categories && Array.isArray(categories)) {
          return categories.map((category, ind) => <Tag key={ind}>{category.label}</Tag>)
        }
        return '';
      },
      sorter: (a, b) => {
        const first = Array.isArray(a.category) ? a.category[0] : {};
        const second = Array.isArray(b.category) ? b.category[0] : {};
        const firstLabel = first.label || '';
        const secondLabel = second.label || '';
        return ('' + firstLabel).localeCompare(secondLabel)
      },
    },
    {
      title: t('Start Date'),
      dataIndex: 'dateOfEvent',
      render: (value) => {
        return moment(value).format('DD MMM YYYY');
      },
      sorter: (a, b) => moment(a.dateOfEvent).diff(moment(b.dateOfEvent)),
    },
    {
      title: t('End Date'),
      dataIndex: 'endDate',
      render: (value) => {
        return moment(value).format('DD MMM YYYY');
      },
      sorter: (a, b) => moment(a.endDate).diff(moment(b.endDate)),
    },
  ],
  other: [
    {
      title: t('ID'),
      dataIndex: 'datastakeId',
      render: (id) => {
        if (isProxy()) {
          return (
            <a
              href="#"
              onClick={() => {
                openDSWindow({
                  url: `/proxy/${mod}/view/event/${id}`,
                  name: `Event ${id}`,
                });
              }}
            >
              {id}
            </a>
          )
        }
        return <Link target="_blank" to={`/app/${mod}/view/event/${id}`}>{id}</Link>
      },
      sorter: (a, b) => ('' + a.datastakeId).localeCompare(b.datastakeId),
    },
    {
      title: t('Title'),
      dataIndex: 'title',
      ellipsis: true,
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
    },
    {
      title: t('Location'),
      dataIndex: 'location',
      sorter: (a, b) => ('' + a.location).localeCompare(b.location),
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      render: (value) => {
        return moment(value).format('DD MMM YYYY');
      },
      sorter: (a, b) => moment(a.dateOfEvent).diff(moment(b.dateOfEvent)),
    },
  ],
});

export default columns;
